import { Snowflake } from 'lucide-react';
import { winterDone, winterPending } from '../lib/winter';

// single object: pending winter drain (yellow) -> drained / frost-proof (green)
export default function WinterCheck({ t, obj, patch }) {
  const done = obj.winter === 'done';
  return (
    <div className={`fx-box wi-box ${done ? 'wi-done' : 'wi-pend'}`} data-testid="winter-check">
      <b><Snowflake size={14} /> {done ? t.wiDone : t.wiPending}</b>
      {done
        ? <button className="btn btn-outline btn-sm" data-testid="winter-undo-btn" onClick={() => patch(winterPending(obj, t))}>{t.wiUndo}</button>
        : <button className="btn btn-green btn-sm" data-testid="winter-done-btn" onClick={() => patch(winterDone(obj, t))}>✅ {t.wiDone}</button>}
    </div>
  );
}
